// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2HN27","content":"Consent_content__2H0RS","footer":"Consent_footer__1ZIYC"};